import dynamicAPI from '../dynamicAPI';
import { useQuery } from 'react-query';

const url = '/api/auth/user-categories';

export default function useAdminUserCategoriesHook({
                                                   page = 1,
                                                   q = '',
                                                   limit = 50,
                                                   enabled = true,
                                               } = {}) {
    const getAdminCategories = useQuery(
        ['adminCategories', page, q, limit],
        async () => {
            const res = await dynamicAPI(
                'get',
                `${url}?page=${page}&q=${encodeURIComponent(q)}&limit=${limit}`,
                {}
            );
            if (res?.error) throw new Error(res.error);
            return res;
        },
        {
            retry: 0,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 5, // 5 minutes
            enabled, // <- only fire when caller wants it
        }
    );

    return { getAdminCategories };
}
